<template>
  <el-container
    style="height: 100vh; min-width: 1200px"
    v-loading.fullscreen.lock="pageLoading"
  >
    <!-- 切换主菜单 -->
    <el-drawer
      :visible.sync="menuBarDrawer"
      direction="ltr"
      :with-header="false"
      size="259px"
    >
      <ul class="mainMenu">
        <draggable
          class="drag-from"
          :list="mainMenu"
          group="form"
          :options="{
            animation: 300,
            chosenClass: 'choose',
            sort: true,
          }"
          @end="handleSort"
        >
          <li
            v-for="item in mainMenu"
            :key="item.value"
            :style="{
              'background-color':
                menuBar.name === item.name ? 'rgb(243, 245, 248)' : '#fff',
            }"
            @click="handleMenuBar(item)"
          >
            {{ item.name }}
          </li>
        </draggable>
      </ul>
    </el-drawer>

    <el-dialog
      title="修改名称和图标"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="dialogBeforeClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form ref="form" label-width="80px" label-position="top">
          <el-form-item label="名称">
            <el-input
              v-model="app.formName"
              placeholder="给应用命名，例如“客户管理系统”"
            ></el-input>
          </el-form-item>

          <el-form-item label="图标">
            <el-popover placement="bottom" width="320px" trigger="click">
              <div
                class="center icon"
                slot="reference"
                :style="{ background: appColors[app.bgColor] }"
              >
                <svg-icon :icon-class="app?.pcLogo || 1"></svg-icon>
              </div>
              <div class="appColorsBox">
                <div class="top">
                  <span
                    v-for="(item, index) in appColors"
                    :key="item"
                    :style="{ background: item }"
                    :class="{ active: index === app.bgColor }"
                    @click="app.bgColor = index"
                  ></span>
                </div>
                <div class="body">
                  <div v-for="item in 20" :key="item">
                    <div
                      class="center body-icon"
                      :style="{ background: appColors[app.bgColor] }"
                      @click="app.pcLogo = item"
                      :class="{ active: item === app.pcLogo }"
                    >
                      <svg-icon :icon-class="item + ''"></svg-icon>
                    </div>
                  </div>
                </div>
              </div>
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogBeforeClose" size="mini">取 消</el-button>
        <el-button type="primary" @click="submit" size="mini">确 定</el-button>
      </div>
    </el-dialog>

    <el-aside width="260px" v-show="!isCollapse">
      <svg-icon
        icon-class="aside_open"
        class="closeBtn"
        @click="isCollapse = !isCollapse"
      ></svg-icon>
      <div class="filter">
        <div
          style="
            cursor: pointer;
            display: flex;
            align-items: center;
            color: #1f1f1f;
            font-size: 14px;
            padding-left: 4px;
          "
        >
          <div
            style="
              width: 32px;
              height: 32px;
              box-shadow: 0px 0px 8px 0px #d0daf0;
              border-radius: 6px 6px 6px 6px;
              margin-right: 10px;
            "
            class="center"
            @click="toWorkbench"
          >
            <svg-icon icon-class="home" style="font-size: 14px"></svg-icon>
          </div>
          <span @click="menuBarDrawer = !menuBarDrawer"
            >【{{ menuBar.name }}】</span
          >
          <svg-icon icon-class="down" style="font-size: 14px"></svg-icon>
        </div>
        <div
          style="position: relative; margin-top: 20px; gap: 10px"
          class="center"
        >
          <el-select
            v-model="filterPageList"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="搜索表单"
            :remote-method="querySearch"
            :loading="querySearchLoading"
            value-key="id"
            @change="handleSelect"
          >
            <el-option-group
              v-for="group in querySearchOptions"
              :key="group.id"
              :label="group.name"
            >
              <el-option
                v-for="item in group.items"
                :key="item.id"
                :label="item.formName"
                :value="item"
              >
                {{ item.formName }}
              </el-option>
            </el-option-group>
          </el-select>

          <svg-icon
            icon-class="groupAdd"
            style="font-size: 24px; cursor: pointer"
            v-if="isAdmin"
            @click="addGroup"
          ></svg-icon>
          <i class="el-icon-search"></i>
        </div>
      </div>
      <el-menu
        :default-active="defaultActive"
        :default-openeds="defaultOpeneds"
        unique-opened
      >
        <draggable
          :list="list"
          group="list"
          handle=".el-icon-menu"
          :options="{
            animation: 300,
            sort: true,
            scroll: true,
            chosenClass: 'choose',
          }"
          @end="handleItemsSort"
        >
          <el-submenu
            :index="indexs + 1 + ''"
            v-for="(items, indexs) in list"
            :key="items.id"
          >
            <template slot="title">
              <div class="el-menu-item-box">
                <div>
                  <svg-icon
                    icon-class="groupOpen"
                    style="font-size: 24px"
                    class="el-icon-menu"
                    v-if="indexs + 1 + '' === defaultActive?.split('-')[0]"
                  ></svg-icon>
                  <svg-icon
                    icon-class="groupClose"
                    style="font-size: 24px"
                    class="el-icon-menu"
                    v-else
                  ></svg-icon>
                  <span class="name">
                    {{ items.name }}
                    <span
                      style="
                        font-size: 12px;
                        color: #6d6d6d;
                        padding-bottom: 5px;
                        display: inline-block;
                        margin-left: 2px;
                      "
                      >{{
                        items.items?.length > 0 ? `(${items.items.length})` : ""
                      }}</span
                    >
                  </span>
                </div>
                <el-dropdown
                  @command="handleCommand($event, items)"
                  class="adminBtn"
                  v-if="isAdmin"
                >
                  <svg-icon
                    icon-class="add"
                    style="font-size: 16px"
                    @click.stop
                  ></svg-icon>
                  <el-dropdown-menu slot="dropdown" :append-to-body="false">
                    <el-dropdown-item command="add">新增表单</el-dropdown-item>
                    <el-dropdown-item command="addDashboard"
                      >新增仪表盘</el-dropdown-item
                    >
                    <el-dropdown-item command="edit">重命名</el-dropdown-item>
                    <el-dropdown-item command="del">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>

            <draggable
              :list="items.items"
              group="items"
              handle=".el-icon-more-outline"
              :options="{
                animation: 300,
                sort: true,
                scroll: true,
                chosenClass: 'choose',
              }"
              @end="handleItemsSort"
            >
              <el-menu-item
                :index="`${indexs + 1}-${index + 1}`"
                v-for="(item, index) in items.items"
                :key="item.formId"
                @click="
                  handleRouter(
                    item,
                    indexs + 1 + '',
                    `${indexs + 1}-${index + 1}`
                  )
                "
              >
                <div class="el-menu-item-box" style="padding-left: 28px">
                  <div class="center">
                    <div
                      :style="{ background: appColors[item?.bgColor || 0] }"
                      style="width: 24px; height: 24px; border-radius: 50%"
                      class="center"
                    >
                      <svg-icon
                        :icon-class="item?.pcLogo || 1"
                        style="font-size: 16px; color: #ffffff"
                      ></svg-icon>
                    </div>
                    <span style="margin-left: 13px; color: #1f1f1f">{{
                      item.formName
                    }}</span>
                  </div>
                  <el-dropdown
                    @command="handleDesignCommand(item, $event)"
                    v-if="isAdmin"
                    class="adminBtn"
                  >
                    <i style="font-size: 16px" class="el-icon-more"></i>
                    <el-dropdown-menu slot="dropdown" :append-to-body="false">
                      <el-dropdown-item
                        command="design"
                        v-if="item.formType === 1"
                        >设计表单</el-dropdown-item
                      >
                      <el-dropdown-item command="eidtDesign" v-else
                        >编辑仪表盘</el-dropdown-item
                      >
                      <el-dropdown-item command="update"
                        >修改名称和图标</el-dropdown-item
                      >
                      <el-dropdown-item command="copy">复制</el-dropdown-item>
                      <el-dropdown-item command="del">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </el-menu-item>
            </draggable>
          </el-submenu>
        </draggable>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header>
        <!-- 开启主菜单 -->
        <div class="center" style="gap: 12px">
          <svg-icon
            icon-class="aside_open"
            class="openBtn"
            style="font-size: 24px; cursor: pointer; transform: rotate(180deg)"
            v-if="isCollapse"
            @click="isCollapse = false"
          ></svg-icon>
          <div style="color: #1d2129; font-size: 18px; font-weight: 500">
            {{ tableName }}
          </div>
          <div
            style="
              width: 82px;
              height: 32px;
              background: #f3f7ff;
              border-radius: 4px;
              cursor: pointer;
            "
            class="center"
            @click="changeFilter"
          >
            <span style="color: #107fff; font-size: 14px">筛选</span>
            <i
              class="el-icon-d-arrow-right"
              style="
                transform: rotate(90deg);
                margin-left: 11px;
                font-size: 12px;
                color: #107fff;
                transition: all 0.3s ease-in-out;
              "
              :style="{
                transform: isFilter ? 'rotate(90deg)' : 'rotate(-90deg)',
              }"
            ></i>
          </div>
          <div class="center" style="cursor: pointer" @click="reset">
            <svg-icon
              icon-class="icon_refresh_right"
              style="margin-right: 7px; font-size: 14px; color: #4e5969"
            ></svg-icon>
            <span style="color: #4e5969; font-size: 14px; line-height: 1"
              >重置</span
            >
          </div>
        </div>
        <Photo></Photo>
      </el-header>

      <el-container>
        <template v-if="tableData.formType === 2">
          <div style="height: 100%; width: 100%">
            <grid-layout
              :layout.sync="previewList"
              :col-num="60"
              :row-height="10"
              :is-draggable="false"
              :is-resizable="false"
              :vertical-compact="true"
              :margin="[10, 10]"
              :use-css-transforms="true"
            >
              <grid-item
                v-for="(item, index) in previewList"
                :key="index"
                :x="item.x"
                :y="item.y"
                :w="item.w"
                :h="item.h"
                :i="item.i"
                style="touch-action: none"
              >
                <el-card style="width: 100%; height: 100%; user-select: none">
                  <SummarySheet
                    :tableName="item.name"
                    :previewData="item.dataArr"
                    :previewVal="item"
                    v-if="item.type === 'pivot_table'"
                  ></SummarySheet>
                  <DataTable :previewData="item" v-else></DataTable>
                  <div class="operate">
                    <el-tooltip content="导出" effect="dark" placement="bottom">
                      <svg-icon
                        icon-class="icon_export"
                        style="font-size: 14px; vertical-align: bottom"
                        @click="exportExcel(item)"
                      ></svg-icon>
                    </el-tooltip>
                  </div>
                </el-card>
              </grid-item>
            </grid-layout>
          </div>
        </template>
        <template v-else>
          <el-empty
            description="暂无数据"
            v-if="!formIds"
            style="margin: auto"
          ></el-empty>
          <div class="homePage" v-else>
            <div
              :style="{
                maxHeight: isFilter ? '209px' : '109px',
                overflow: isFilter ? 'auto' : 'hidden',
              }"
            >
              <Search
                ref="Search"
                :searchList="searchList"
                :pageNumber.sync="pageNumber"
                :formData.sync="formData"
                v-if="tableList.search"
              />
            </div>
            <div class="mian">
              <div
                class="contentCop"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="#fff"
              >
                <Content
                  ref="Content"
                  :tableList="tableList"
                  :defaultTable.sync="defaultTable"
                  :sublist="sublist"
                  :pageNumber="pageNumber"
                  :pageSize="pageSize"
                  :formData.sync="formData"
                  v-if="tableList.field"
                />
              </div>
              <div class="footer">
                <div class="center" style="gap: 9px">
                  <div
                    v-for="item in typeColors"
                    :key="item.color"
                    class="center"
                  >
                    <span
                      style="
                        width: 10px;
                        height: 10px;
                        border: 1px solid #e5e8ed;
                        border-radius: 50%;
                        margin-right: 2px;
                      "
                      :style="{ background: item.color }"
                    ></span>
                    <span style="font-size: 12px; color: #6d6d6d">{{
                      item.name
                    }}</span>
                  </div>
                </div>
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="10"
                  :current-page="pageNumber"
                  layout="total, sizes, prev, pager, next"
                  :total="total"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </template>
      </el-container>
    </el-container>
  </el-container>
</template>
<script>
import draggable from "vuedraggable";
import {
  getFormGroups,
  deleteGroup,
  updateGroup,
  copyForm,
  renameForm,
  delForm,
  addDashboard,
  quickUpdate,
  reportExport,
  tableExport,
} from "@/api/design";
import Search from "./searchComps/index";
import Content from "./content";
import { getPageViewList } from "@/api/process";
import { getReportData, getReportList, getTableData } from "@/api/design";
import { moduleListSort, formSearch, formMove } from "@/api/module";
import * as dd from "dingtalk-jsapi";
import { changeTime } from "@/utils/CustomUtil.js";
import Photo from "@/components/Photo.vue";
import SummarySheet from "@/components/SummarySheet";
import DataTable from "@/components/DataTable";
import { GridLayout, GridItem } from "vue-grid-layout";
import { download } from "@/utils/export.js";

export default {
  name: "Home",
  components: {
    Search,
    Content,
    draggable,
    Photo,
    SummarySheet,
    DataTable,
    GridLayout,
    GridItem,
  },
  data() {
    return {
      formData: {},
      querySearchOptions: [],
      querySearchLoading: false,
      filterPageList: "",
      menuBarDrawer: false,
      menuBar: {
        id: "1",
        name: "",
      },
      expand: "",
      list: [],
      isCollapse: false,
      formIds: "",
      tableList: {}, //表单内容
      loading: false, //表单内容loading
      total: 0,
      pageSize: 10,
      pageNumber: 1,
      searchList: [], //搜索参数
      defaultOpeneds: ["1"],
      defaultActive: "1-1",
      pageLoading: false, //整个页面loading
      todoNum: 0, //待办数量
      defaultTable: "", //子表id
      sublist: [], //子表列表
      // 表单排序
      sort: "",
      sortType: "",
      isFilter: false,
      typeColors: [
        {
          name: "草稿",
          color: "#FA8118",
        },
        {
          name: "已生效",
          color: "#FFFFFF",
        },
        {
          name: "进行中",
          color: "#46C26F",
        },
        {
          name: "已取消",
          color: "#8893A7",
        },
      ],
      dialogVisible: false,
      app: {
        id: "",
        formName: "",
        pcLogo: 1,
        bgColor: 0,
      },
      appColors: ["#FA8118", "#56CA56", "#0AB1F7", "#107FFF", "#686FFF"],
      previewList: [],
      exportLoading: false,
    };
  },
  computed: {
    mainMenu() {
      return this.$store.state.formData.moduleList;
    },
    isAdmin() {
      return this.$store.getters.userInfo.isAdmin;
    },
    isDD() {
      return dd.env.platform !== "notInDingTalk" ? true : false;
    },
    tableData() {
      console.log(this.$store.state.formData);
      return this.$store.state.formData.tableData;
    },
    tableName() {
      return this.$store.state.formData.tableData.formName || "表单";
    },
  },
  created() {
    this.setLoginInfo();
  },
  provide() {
    return {
      getViewList: this.getViewList,
    };
  },
  methods: {
    toWorkbench() {
      this.$store.commit("formData/setTableData", {});
      this.$router.push({ path: "/workbench" });
    },
    async submit() {
      await quickUpdate(this.app);
      this.dialogBeforeClose();
      this.$message.success("修改成功");
      this.getList();
    },
    dialogBeforeClose() {
      this.dialogVisible = false;
      this.app = {
        id: "",
        formName: "",
        pcLogo: 1,
        bgColor: 0,
      };
    },
    reset() {
      this.searchList.forEach((item) => {
        this.$set(this.formData, item.code, null);
      });
      this.getViewList(null, null, false);
    },
    // 初始化加载
    async setLoginInfo() {
      let menuBar = JSON.parse(localStorage.getItem("menuBar"));
      if (menuBar) {
        this.menuBar = menuBar;
      }
      this.getList();
    },

    // 列表排序
    handleItemsSort() {
      formMove(this.list);
    },
    // 表单筛选切换
    async handleSelect(val) {
      if (!val) return;
      this.menuBar = { id: val.moduleId, name: val.moduleName };
      localStorage.setItem("menuBar", JSON.stringify(this.menuBar));
      this.filterPageList = null;
      this.activeRouter(this.list, val.id);
    },

    // 表单筛选搜索
    async querySearch(queryString) {
      this.querySearchLoading = true;
      let res = await formSearch(queryString);
      res.data.forEach((item) => {
        item.items.forEach((items) => {
          items.moduleId = item.id;
          items.moduleName = item.name;
        });
      });
      this.querySearchOptions = res.data;
      this.querySearchLoading = false;
    },
    // 主表单排序
    async handleSort() {
      try {
        await moduleListSort(this.mainMenu);
        this.$message.success("排序成功");
      } catch (error) {
        this.$message.info("排序失败");
      }
    },
    // 主表单切换
    handleMenuBar(item) {
      this.menuBar = { id: item.id, name: item.name };
      this.menuBarDrawer = false;
      localStorage.setItem("menuBar", JSON.stringify(item));
      // 制空路由
      this.$router.push(
        {
          query: {
            code: "",
          },
        },
        () => {}
      );
      this.getList();
    },

    handleSizeChange(val) {
      if (!this.total) return;
      this.pageSize = val;
      this.getViewList(null, null, false);
    },
    handleCurrentChange(val) {
      if (!this.total) return;
      this.pageNumber = val;
      this.getViewList(null, null, false);
    },
    // 添加组名
    addGroup() {
      this.$prompt("请输入要添加的组名", "新的分组名", {
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        inputPattern: /^[\u4E00-\u9FA5A-Za-z0-9\\-]{1,30}$/,
        inputErrorMessage: "分组名不能为空且长度小于30",
        inputPlaceholder: "请输入分组名",
      })
        .then(({ value }) => {
          updateGroup({ name: value, moduleId: this.menuBar.id }).then(() => {
            this.$message.success("新增成功");
            this.getList();
          });
        })
        .catch(() => {});
    },

    // 表单设置
    async handleDesignCommand(item, e) {
      if (e === "design") {
        this.$router.push(`/admin/design?code=${item.id}`);
      } else if (e === "eidtDesign") {
        this.$router.push(`/design?code=${item.id}`);
      } else if (e === "update") {
        this.app = {
          formName: item.formName,
          id: item.id,
          bgColor: item.bgColor ? item.bgColor : 0,
          pcLogo: item.pcLogo ? item.pcLogo : 1,
        };
        this.dialogVisible = true;
      } else if (e === "del") {
        this.$confirm("此操作将永久删除该表单, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            if (item.id === this.$route.query.code) {
              this.formIds = null;
            }
            this.pageLoading = true;
            await deleteGroup(item.id);
            this.$message.success("删除成功");
            this.$router.push(
              {
                query: {
                  code: "",
                },
              },
              () => {}
            );
            this.getList();
            this.pageLoading = false;
          })
          .catch(() => {});
      } else {
        this.$confirm("确定复制该表单, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.pageLoading = true;
            await copyForm(item.id);
            this.$message.success("复制成功");
            this.getList();
            this.pageLoading = false;
          })
          .catch(() => {
            // this.$message.info("已取消复制");
          });
      }
    },
    // 组名设置
    handleCommand(str, item) {
      switch (str) {
        case "add":
          this.$router.push("/admin/design?groupId=" + item.id);
          this.$store.commit("setDataNameList", []);
          break;
        case "addDashboard":
          addDashboard({ groupId: item.id }).then((res) => {
            console.log(res);
            this.$router.push(`/design?code=${res.data}`);
          });
          break;
        case "edit":
          this.$prompt("请输入新的组名", "重命名", {
            confirmButtonText: "提交",
            cancelButtonText: "取消",
            inputPattern: /^[\u4E00-\u9FA5A-Za-z0-9\\-]{1,30}$/,
            inputErrorMessage: "分组名不能为空且长度小于30",
            inputPlaceholder: "请输入分组名",
            inputValue: item.name,
          })
            .then(async ({ value }) => {
              await renameForm({ name: value, id: item.id });
              this.$message.success("编辑成功");
              this.getList();
            })
            .catch(() => this.$message.error("已取消"));
          break;
        case "del":
          this.$confirm("确定删除该分组, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              this.pageLoading = true;
              const res = await delForm(item.id);
              if (res.code !== 200) {
                this.pageLoading = false;
                return this.$message.error(res.message);
              }
              this.$message.success("删除成功");
              this.$router.push(
                {
                  query: {
                    code: "",
                  },
                },
                () => {}
              );
              this.getList();
              this.pageLoading = false;
            })
            .catch(() => {});
          break;
      }
    },
    // 获取页面信息
    async getList() {
      // 请求表单数据
      let res = await getFormGroups(this.menuBar.id || 1);
      // 侧边栏数据
      this.list = res.data;
      // 设置设计表单数据标题
      this.$store.commit("setRouterList", this.list);
      // 无权限板块
      if (!res.data[0]) {
        this.total = 0;
        this.$message.info("该模块没有数据！");
        this.formIds = "";
        return;
      }
      // 设置侧边栏选中
      this.activeRouter(res.data, this.$route.query.code || "");
    },

    // 获取表单信息
    async getViewList(sort, order, isOne = true) {
      console.log(sort, order, isOne);
      if (this.tableData.formType === 2) {
        this.getReport();
      } else {
        if (sort && order) {
          this.sort = sort;
          this.order = order;
        }
        this.loading = true;
        // 获取默认搜索条件

        let result = await getPageViewList({
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          formId: this.tableData.formId,
          sort: this.sort,
          order: this.order,
          searchParamsJson: this.formData,
          subFormId: this.defaultTable,
        });
        this.total = result.data.data.total || 0;
        if (this.total <= 10) this.pageNumber = 1;
        this.tableList = result.data;
        // 子表表单
        this.$store.commit(
          "formData/setExternalBtnPermission",
          result.data.btns || []
        );
        if (isOne) {
          if (result.data.search) {
            for (const item of result.data.search) {
              // 使用 for...of 循环替换 forEach
              if (item.defaultValue) {
                this.$set(
                  this.formData,
                  item.code,
                  changeTime(
                    item.defaultValue,
                    item.format || "yyyy-MM-dd HH:mm:ss"
                  )
                );
              }
            }
          }
        }
        this.searchList = result.data.search;
        this.sublist = result.data.table;
        this.$store.commit("formData/setRefresh", false);
        this.loading = false;
      }
    },

    async getReport() {
      const res = await getReportList(this.tableData.id);
      this.previewList = [];
      res.data.forEach((item, index) => {
        if (item.type === "pivot_table") {
          getReportData({ id: item.id }).then(({ data: res }) => {
            const dataArr = {
              header: [],
              data: [],
            };
            res.yFields.forEach((item, index) => {
              const arr = [];
              arr.push(item.name);
              res.data.val.forEach((val) => {
                if (val.y) {
                  arr.push(val.y[index]);
                } else {
                  arr.push("汇总");
                }
              });
              dataArr.header.push(arr);
            });
            let xFields = [];
            if (res.xFields.length > 0) {
              xFields = res.xFields.map((item) => item.name);
            } else {
              xFields = [""];
            }
            res.data.val.forEach((val) => {
              xFields.push(val.name);
            });
            dataArr.header.push(xFields);
            let result = [];
            const sum = ["汇总"];
            if (res.data.x.length > 0) {
              const { x, val } = res.data;
              const dataLength = x[0].data.length;
              result = Array.from({ length: dataLength }, (_, i) => [
                ...x.map((item) => item.data[i]),
                ...val.map((item) => item.data[i]),
              ]);
              res.data.val.forEach((val) => {
                sum.push(val.sum);
              });
            } else {
              result = [];
              res.data.val.forEach((val) => {
                sum.push(val.sum);
              });
            }
            result.push(sum);
            dataArr.data = result;
            this.previewList.push({
              ...res,
              i: index,
              dataArr,
              type: "pivot_table",
            });
          });
        } else {
          getTableData({ id: item.id, pageNumber: 1, pageSize: 20 }).then(
            ({ data }) => {
              this.previewList.push({
                ...data,
                i: index,
                type: "data_table",
              });
            }
          );
        }
      });
    },

    // 侧边栏点击
    handleRouter(item, indexs, index) {
      if (item.id === this.formIds) return;
      if (indexs && index) {
        this.defaultOpeneds = [indexs + ""];
        this.defaultActive = index;
      }
      this.isFilter = false;
      this.pageNumber = 1;
      this.sort = "";
      this.order = "";
      this.defaultTable = item.id;
      this.$store.commit("formData/setTableData", { ...item, formId: item.id });
      this.formIds = item.id;
      if (!this.formIds) return this.$message.info("该模块没有数据");
      document.title = item.formName;
      // 必须传其中一个，否则会报错
      this.$router.push(
        {
          query: {
            code: this.formIds,
          },
        },
        () => {}
      );
      this.tableList = {};
      this.formData = {};
      this.getViewList();
    },

    // 设置侧边栏选中
    activeRouter(data, id) {
      const result = id ? id : data[0].items[0].id;
      data.forEach((pItem, pIndex) => {
        pItem.items &&
          pItem.items.forEach((sItem, sIndex) => {
            // console.log(sItem, id);
            if (sItem.id === result) {
              this.handleRouter(
                sItem,
                pIndex + 1 + "",
                `${pIndex + 1}-${sIndex + 1}`
              );
            }
          });
      });
    },

    // 跳转设计页面
    handleDesign() {
      if (!this.$route.query.code) return;
      this.$router.push("/admin/design?code=" + this.$route.query.code);
    },
    changeFilter() {
      this.$nextTick();
      this.isFilter = !this.isFilter;
    },
    async exportExcel(item) {
      if (this.exportLoading) return;
      this.exportLoading = true;
      if (item.type === "pivot_table") {
        const res = await reportExport({ id: item.id });
        download(res, this.$store.getters.formName);
        this.$message.success("导出成功");
        this.exportLoading = false;
      } else {
        const res = await tableExport({ id: item.id });
        download(res, this.$store.getters.formName);
        this.$message.success("导出成功");
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.icon {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  cursor: pointer;
  .svg-icon {
    width: 40px;
    height: 40px;
    color: #fff;
  }
}

.appColorsBox {
  padding: 8px;
  .top {
    display: flex;
    gap: 16px;
    padding-bottom: 18px;
    padding-left: 8px;
    span {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      cursor: pointer;
      box-sizing: border-box;
      &.active {
        border: 2px solid #b0d5ff;
      }
    }
  }
}

.body {
  width: 300px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  background: #f5f6f8;
  padding: 10px;
  border-radius: 4px;
}

.body-icon {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  cursor: pointer;
  color: #fff;
  .svg-icon {
    width: 30px;
    height: 30px;
    color: #fff;
  }
  &.active {
    border: 2px solid #b0d5ff;
  }
}

.el-menu-item-box {
  width: 100%;
  padding-left: 14px;
  padding-right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .name {
    width: 100%;
    font-size: 14px;
    color: #1f1f1f;
    margin-left: 13px;
  }
  .adminBtn {
    opacity: 0;
    display: flex;
    align-items: center;
  }
  &:hover {
    .adminBtn {
      opacity: 1;
    }
  }
}

.el-header {
  color: #333;
  font-size: 16px;
  height: 52px !important;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
}

.mainMenu {
  padding: 0 12px;
  color: #304265;
  margin-top: 5px;
  li {
    padding: 4px 16px;
    border-radius: 4px;
    height: 40px;
    line-height: 40px;
    &:hover {
      background-color: rgb(243, 245, 248);
      cursor: pointer;
    }
  }
}

.mian {
  min-width: 600px;
  overflow: hidden;
  background: #f5f7fa;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.el-container {
  overflow: hidden;
}
.el-aside {
  color: #333;
  overflow-x: hidden;
  padding-top: 50px;
  box-shadow: inset -1px 0px 0px 0px #e5e6eb;
  padding-top: 104px;
  // position: relative;
  .closeBtn {
    position: absolute;
    top: 14px;
    font-size: 24px;
    z-index: 3;
    color: #b3c0d1;
    cursor: pointer;
    left: 247px;
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }
  &:hover .closeBtn {
    opacity: 1;
  }
  .filter {
    position: absolute;
    top: 0;
    left: 0;
    padding: 12px;
    background-color: #fff;
    z-index: 2;
    width: 260px;
    border-right: 1px solid #e6e6e6;

    /deep/.el-input__inner {
      border-radius: 14px;
      padding-left: 28px;
      height: 28px;
      background: #f3f5f8;
      border-color: transparent;
      &::placeholder {
        font-size: 14px;
      }
    }
  }
  /deep/.el-select .el-input__inner:focus {
    border-color: #107fff;
  }
  .el-icon-search {
    position: absolute;
    z-index: 2;
    left: 10px;
    top: 8px;
    font-size: 12px;
    color: #c5c8d0;
  }
}

.el-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1px !important;
  height: 40px;
  margin-top: 2px;
  line-height: 40px;
  padding: 0;
}

/deep/ .el-submenu {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 8px;
  border-radius: 4px;

  &__title {
    padding: 0 !important;
    padding-left: 1px !important;
    display: flex;
    align-items: center;
  }
}

/deep/ .el-menu-item {
  border-radius: 4px;
  &:hover {
    background-color: #ecf5ff;
  }
  &.is-active {
    background-color: #ecf5ff;
  }
}

/deep/.el-submenu__title {
  height: 40px;
  line-height: 40px;
  &:hover {
    background-color: #ecf5ff;
    border-radius: 4px;
  }
}

/deep/ .el-card__body,
.mian {
  padding: 10px;
}

.homePage {
  display: flex;
  flex-direction: column;
  min-width: 600px;
  width: 100%;
  background: #fff;
  // justify-content: space-between;

  .contentCop {
    flex: 1;
    width: 100%;
    padding: 10px;
    padding-bottom: 0px;
    background: #fff;
    border: 1px solid #e5e6eb;
    border-bottom: unset;
    height: calc(100% - 68px);
  }
  .footer {
    height: 68px;
    background: #fff;
    border: 1px solid #e5e6eb;
    border-top: unset;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
  }
}

/deep/ .el-submenu__icon-arrow {
  display: none;
}

:deep(.el-card__body) {
  padding: 10px;
  height: 100%;
  position: relative;
  .operate {
    position: absolute;
    top: 4px;
    right: 0;
    z-index: 2;
    padding-right: 10px;
    display: flex;
    cursor: pointer;
    align-items: center;
    padding-top: 5px;
    .svg-icon {
      display: none;
      margin-left: 10px;
      font-size: 14px;
    }
  }
  &:hover {
    .operate {
      .svg-icon {
        display: block;
      }
    }
  }
}
</style>
